/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Nottitle1Inputs */

const id_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang BUKAN egdata.app`)
};

const ms_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang egdata.app BUKAN`)
};

const da_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvad egdata.app IKKE er`)
};

const de_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was egdata.app NICHT ist`)
};

const en_us2_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What egdata.app is NOT`)
};

const es_es2_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo que egdata.app NO es`)
};

const es_mx2_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo que egdata.app NO es`)
};

const fil_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ano ang egdata.app HINDI`)
};

const fr_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce qu'egdata.app n'est PAS`)
};

const it_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa egdata.app NON è`)
};

const hu_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit NEM az egdata.app`)
};

const nl_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat egdata.app NIET is`)
};

const no_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hva egdata.app IKKE er`)
};

const pl_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czym egdata.app NIE jest`)
};

const pt_br2_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que egdata.app NÃO É`)
};

const pt_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que o egdata.app NÃO é`)
};

const ro_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce NU este egdata.app`)
};

const fi_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitä egdata.app EI ole`)
};

const sv_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vad egdata.app INTE är`)
};

const vi_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app KHÔNG phải là gì`)
};

const tr_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app NE DEĞİLDİR`)
};

const cs_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co egdata.app NENÍ`)
};

const bg_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Какво egdata.app НЕ е`)
};

const ru_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чем egdata.app НЕ является`)
};

const uk_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чим egdata.app НЕ є`)
};

const ar_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ما ليس egdata.app`)
};

const hi_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app क्या नहीं है`)
};

const th_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สิ่งที่ egdata.app ไม่ใช่`)
};

const ja_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app ではないもの`)
};

const zh_cn2_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app 不是什么`)
};

const zh_hant1_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app 不是什麼`)
};

const ko_about_nottitle1 = /** @type {(inputs: About_Nottitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app이 아닌 것`)
};

/**
* | output |
* | --- |
* | "What egdata.app is NOT" |
*
* @param {About_Nottitle1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const about_nottitle1 = /** @type {((inputs?: About_Nottitle1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Nottitle1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_about_nottitle1(inputs)
	if (locale === "ms") return ms_about_nottitle1(inputs)
	if (locale === "da") return da_about_nottitle1(inputs)
	if (locale === "de") return de_about_nottitle1(inputs)
	if (locale === "en-US") return en_us2_about_nottitle1(inputs)
	if (locale === "es-ES") return es_es2_about_nottitle1(inputs)
	if (locale === "es-MX") return es_mx2_about_nottitle1(inputs)
	if (locale === "fil") return fil_about_nottitle1(inputs)
	if (locale === "fr") return fr_about_nottitle1(inputs)
	if (locale === "it") return it_about_nottitle1(inputs)
	if (locale === "hu") return hu_about_nottitle1(inputs)
	if (locale === "nl") return nl_about_nottitle1(inputs)
	if (locale === "no") return no_about_nottitle1(inputs)
	if (locale === "pl") return pl_about_nottitle1(inputs)
	if (locale === "pt-BR") return pt_br2_about_nottitle1(inputs)
	if (locale === "pt") return pt_about_nottitle1(inputs)
	if (locale === "ro") return ro_about_nottitle1(inputs)
	if (locale === "fi") return fi_about_nottitle1(inputs)
	if (locale === "sv") return sv_about_nottitle1(inputs)
	if (locale === "vi") return vi_about_nottitle1(inputs)
	if (locale === "tr") return tr_about_nottitle1(inputs)
	if (locale === "cs") return cs_about_nottitle1(inputs)
	if (locale === "bg") return bg_about_nottitle1(inputs)
	if (locale === "ru") return ru_about_nottitle1(inputs)
	if (locale === "uk") return uk_about_nottitle1(inputs)
	if (locale === "ar") return ar_about_nottitle1(inputs)
	if (locale === "hi") return hi_about_nottitle1(inputs)
	if (locale === "th") return th_about_nottitle1(inputs)
	if (locale === "ja") return ja_about_nottitle1(inputs)
	if (locale === "zh-CN") return zh_cn2_about_nottitle1(inputs)
	if (locale === "zh-Hant") return zh_hant1_about_nottitle1(inputs)
	return ko_about_nottitle1(inputs)
});
export { about_nottitle1 as "about.notTitle" }